/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/cidr_match.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns true if the provided IP is contained in one of the provided CIDR blocks.
 *
 * @example
 * FROM hosts
 * | WHERE CIDR_MATCH(ip1, "127.0.0.2/32", "127.0.0.3/32")
 * | KEEP card, host, ip0, ip1
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'cidr_match',
  signatures: [
    {
      params: [
        {
          name: 'ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'blockX',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
    {
      params: [
        {
          name: 'ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'blockX',
          type: 'text',
          optional: false,
        },
      ],
      variadic: true,
      returnType: 'boolean',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
